import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeAppV2';
import bundleLocaleEs from 'Jsx/Shared/CoursesInBundle/i18n/localeEs';
import bundlelocalePt from 'Jsx/Shared/CoursesInBundle/i18n/localePt';

import thirdPartyLoader from 'Utils/thirdPartyLoader/thirdPartyLoader';
import mixpanelProvider from 'Utils/thirdPartyLoader/mixpanelProvider';
import gtagProvider from 'Utils/thirdPartyLoader/gtagProvider';
import gtmProvider from 'Utils/thirdPartyLoader/gtmProvider';
import facebookPixelProvider from 'Utils/thirdPartyLoader/facebookPixelProvider';

import App from './App';

import localeEs from './i18n/localeEs';
import localePt from './i18n/localePt';

import getInitialState from './getInitialState';

import { initialStatePageKey, COURSE_DETAIL_PAGE_KEY } from './constants';

function loadThirdParty() {
  thirdPartyLoader({
    providers: [
      mixpanelProvider(),
      gtagProvider(),
      gtmProvider(),
      facebookPixelProvider(),
    ],
  });
}

const appConfig: Params = {
  App,
  getInitialState,
  initialStatePageKey,
  i18nConfig: {
    pageKey: COURSE_DETAIL_PAGE_KEY,
    defaults: {
      es: { ...localeEs.es, ...bundleLocaleEs.es },
      pt: { ...localePt.pt, ...bundlelocalePt.pt },
    },
  },
  extraState: {},
  onReactDOMRender: () => {
    loadThirdParty();
  },
};

initializeApp(appConfig);
